export default __webpack_public_path__ + "static/media/BB_13.ed5f40ca.png";